import './RAAccordion.scss';

// @ vendors
import React from 'react';
import PropTypes from 'prop-types';

export const RAAccordion = ({ children }) => {
    return <div className="ra-accordion">{children}</div>;
};

RAAccordion.propTypes = {
    id: PropTypes.string,
    children: PropTypes.array,
};
